
// src/config.js
const ENV = import.meta.env.MODE || 'development';

// Define environment-specific configurations
const configs = {
  development: {
    apiUrl: 'https://dev-api-marketwatch.iconflux.info/api/',
    socketUrl: 'wss://dev-api-marketwatch.iconflux.info',
  },
  qa: {
    apiUrl: 'https://qa-api-marketwatch.iconflux.info/api/',
    socketUrl: 'wss://qa-api-marketwatch.iconflux.info',
  },
  production: {
    apiUrl: 'https://static.104.189.27.37.clients.your-server.de/api/',
    socketUrl: 'ws://static.104.189.27.37.clients.your-server.de/ws',
  },
};

export const config = configs[ENV];
